<div class="addon-card">
  <div *ngIf="!editMode" class="addon-card__meta">
    <div class="meta-row">
      <span class="meta-label">{{ "addons.disclaimers.name" | translate }}</span>
      <span class="meta-value">{{ disclaimer.name }}</span>
    </div>
    <div class="meta-row" *ngIf="disclaimer.modifiedAt">
      <span class="meta-label">{{ "modifiedAt" | translate }}</span>
      <span class="meta-value">{{
        disclaimer.modifiedAt | localizedDate: "medium"
      }}</span>
    </div>
    <div class="meta-row">
      <span class="meta-label">{{ "addons.usage.label" | translate }}</span>
      <span class="meta-value" *ngIf="!disclaimer.isUsed">{{
        "addons.usage.notUsed" | translate
      }}</span>
      <div class="addon-usage" *ngIf="disclaimer.isUsed">
        <span class="meta-value">{{
          "addons.usage.usedInCount"
            | translate: { count: (disclaimer.usedInSignatures?.length || 0) }
        }}</span>
        <ul class="addon-usage__list" *ngIf="disclaimer.usedInSignatures?.length">
          <li *ngFor="let signature of disclaimer.usedInSignatures">
            <a [routerLink]="['/signatures', signature.templateId, 'edit']">{{
              signature.name
            }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="addon-card__preview" [innerHTML]="safeHtml"></div>
  </div>

  <form
    [formGroup]="form"
    class="addon-card__form"
    (ngSubmit)="changeDisclaimer()"
    *ngIf="editMode"
  >
    <div class="meta-row" *ngIf="disclaimer.modifiedAt">
      <span class="meta-label">{{ "modifiedAt" | translate }}</span>
      <span class="meta-value">{{
        disclaimer.modifiedAt | localizedDate: "medium"
      }}</span>
    </div>
    <mat-form-field appearance="outline">
      <mat-label>{{ "addons.disclaimers.name" | translate }}</mat-label>
      <input
        matInput
        formControlName="name"
        type="text"
        [errorStateMatcher]="errorStateMatcher"
      />
      <mat-error *ngIf="form.hasError('required', ['name'])">{{
        "fieldRequired" | translate
      }}</mat-error>
    </mat-form-field>

    <app-editor formControlName="htmlContent" [height]="300"></app-editor>
    <mat-error *ngIf="errorStateMatcher.submitAttempted && form.hasError('required', ['htmlContent'])">{{
      "fieldRequired" | translate
    }}</mat-error>
  </form>

  <div class="addon-card__actions">
    <button
      type="button"
      class="action-btn"
      *ngIf="editMode"
      (click)="cancelEditDisclaimer()"
      [attr.aria-label]="'cancel' | translate"
    >
      <mat-icon>cancel</mat-icon>
      {{ "cancel" | translate }}
    </button>
    <button
      type="button"
      class="action-btn"
      *ngIf="editMode"
      (click)="changeDisclaimer()"
      [attr.aria-label]="'save' | translate"
    >
      <mat-icon>save</mat-icon>
      {{ "save" | translate }}
    </button>
    <button
      type="button"
      class="action-btn"
      *ngIf="!editMode"
      (click)="changeEditMode()"
      [attr.aria-label]="'edit' | translate"
    >
      <mat-icon>edit</mat-icon>
      {{ "edit" | translate }}
    </button>
    <button
      type="button"
      class="action-btn action-btn--danger"
      *ngIf="!editMode && !disclaimer.isUsed"
      (click)="removeDisclaimer(disclaimer.addonId)"
      [attr.aria-label]="'delete' | translate"
    >
      <mat-icon>delete_outline</mat-icon>
      {{ "delete" | translate }}
    </button>
  </div>
</div>
